import { ToolSet } from "ai";
import { useEffect, useMemo } from "react";

import base64Tool, { toolIcon as base64Icon } from "components/AssistantPanel/tools/base64";
import useNavigationTool, {
  toolIcon as navigateIcon,
} from "components/AssistantPanel/tools/navigation";
import usePageContextTool, {
  toolIcon as getPageContextIcon,
} from "components/AssistantPanel/tools/pageContext";
import useSearchDocsTool, {
  toolIcon as searchDocsIcon,
} from "components/AssistantPanel/tools/spaceliftDocs";
import { IconComponent } from "types/Icon";

import useChatStore from "../store/useStore";

const TOOL_ICONS: Record<string, IconComponent> = {
  navigate: navigateIcon,
  getPageContext: getPageContextIcon,
  searchDocs: searchDocsIcon,
  base64: base64Icon,
};

const useChatFrontendTools = () => {
  const setFrontendTools = useChatStore((state) => state.setFrontendTools);

  const navigate = useNavigationTool();
  const getPageContext = usePageContextTool();
  const searchDocs = useSearchDocsTool();

  const tools = useMemo((): ToolSet => {
    return {
      navigate,
      getPageContext,
      searchDocs,
      base64: base64Tool,
    };
  }, [navigate, getPageContext, searchDocs]);

  useEffect(() => {
    setFrontendTools(tools);
  }, [setFrontendTools, tools]);

  return { toolIcons: TOOL_ICONS };
};

export default useChatFrontendTools;
